// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3-Q5E";
var _3 = "prev-2axIe";
var _4 = "next-3wAdN";
var _5 = "disabled-zaVA1";
var _6 = "goTo-38QrA";
export { _1 as "__esModule", _2 as "root", _3 as "prev", _4 as "next", _5 as "disabled", _6 as "goTo" }
export default { "__esModule": _1, "root": _2, "prev": _3, "next": _4, "disabled": _5, "goTo": _6 }
